module.exports = __webpack_public_path__ + "img/megaphone.7dd7b54a.svg";